module.exports = __webpack_public_path__ + "static/media/ParamStar.e20750f4.svg";